import { Injectable } from '@angular/core';
import { ICalScanCloudConfig } from '@calsale/scanovate';

@Injectable({
  providedIn: 'root'
})
export abstract class ScanCloudConfig implements ICalScanCloudConfig {
  apiUrl: string;
  docCode?: number;
  classNames?: string;
  iframeStyle?: string;
  /**If in use, Must have the same origin as the parent in order for the scan completion callback to work */
  completeCallbackUrl?: string;

  constructor() {}
}
